/* ════════════════════════════════════════════════
   ORGANIC PANTRY - Production theme.js
   Single IIFE, defensive, never blocks the UI.
   ──────────────────────────────────────────────── */
(function(){
  'use strict';

  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.from((r||document).querySelectorAll(s))}
  function moneyFmt(c){return '$' + ((c||0)/100).toFixed(2)}

  var cartCache = null;

  // ── Mobile nav drawer ──
  function openNav(){
    var n=$('#MobileNav'), o=$('#MobileOverlay'), h=$('.hdr-hamburger');
    if(n){n.classList.add('open');n.setAttribute('aria-hidden','false')}
    if(o){o.classList.add('open');o.setAttribute('aria-hidden','false')}
    if(h)h.setAttribute('aria-expanded','true');
    document.body.style.overflow='hidden';
  }
  function closeNav(){
    var n=$('#MobileNav'), o=$('#MobileOverlay'), h=$('.hdr-hamburger');
    if(n){n.classList.remove('open');n.setAttribute('aria-hidden','true')}
    if(o){o.classList.remove('open');o.setAttribute('aria-hidden','true')}
    if(h)h.setAttribute('aria-expanded','false');
    document.body.style.overflow='';
  }
  window.openNav=openNav;
  window.closeNav=closeNav;

  // ── Mobile search ──
  function toggleMobileSearch(){
    var s=$('#MobileSearch');
    if(!s)return;
    s.classList.toggle('open');
    if(s.classList.contains('open')){
      var i=s.querySelector('input');
      if(i)setTimeout(function(){try{i.focus()}catch(e){}}, 80);
    }
  }
  window.toggleMobileSearch=toggleMobileSearch;

  // ── Tabs ──
  function switchTab(btn,id){
    if(!btn)return;
    var sec=btn.closest('section');
    if(!sec)return;
    $$('.tab-btn',sec).forEach(function(b){b.classList.remove('active');b.setAttribute('aria-selected','false')});
    $$('.tab-panel',sec).forEach(function(p){p.classList.remove('active')});
    btn.classList.add('active');
    btn.setAttribute('aria-selected','true');
    var p=document.getElementById(id);
    if(p)p.classList.add('active');
  }
  window.switchTab=switchTab;

  // ── Cart drawer open/close (no focus management - prevents scroll jumps) ──
  function openCartDrawer(){
    var d=$('#CartDrawer'), o=$('#CartDrawerOverlay');
    if(!d){return}
    d.classList.add('open');
    d.setAttribute('aria-hidden','false');
    if(o)o.classList.add('open');
    document.documentElement.style.overflow='hidden';
  }
  function closeCartDrawer(){
    var d=$('#CartDrawer'), o=$('#CartDrawerOverlay');
    if(d){d.classList.remove('open');d.setAttribute('aria-hidden','true')}
    if(o)o.classList.remove('open');
    document.documentElement.style.overflow='';
  }
  window.openCartDrawer=openCartDrawer;
  window.closeCartDrawer=closeCartDrawer;

  function showAddedToast(){
    var t=$('#CartDrawerToast');
    if(!t)return;
    t.classList.add('show');
    clearTimeout(showAddedToast._t);
    showAddedToast._t=setTimeout(function(){t.classList.remove('show')}, 2400);
  }

  function updateHeaderCount(count){
    $$('.cart-btn').forEach(function(btn){
      var existing=btn.querySelector('.cart-count');
      if(!count || count<1){
        if(existing)existing.remove();
        return;
      }
      if(!existing){
        existing=document.createElement('span');
        existing.className='cart-count';
        existing.setAttribute('aria-hidden','true');
        btn.appendChild(existing);
      }
      existing.textContent=count;
    });
  }

  function renderCartDrawer(cart){
    var empty=$('#CartDrawerEmpty');
    var list=$('#CartDrawerItems');
    var footer=$('#CartDrawerFooter');
    var total=$('#CartDrawerTotal');
    if(!list||!empty||!footer)return;

    cartCache = cart;

    if(!cart || cart.item_count===0){
      empty.style.display='flex';
      list.style.display='none';
      footer.style.display='none';
      return;
    }
    empty.style.display='none';
    list.style.display='block';
    footer.style.display='block';

    list.innerHTML='';
    (cart.items||[]).forEach(function(item,idx){
      var li=document.createElement('li');
      li.className='cd-item';
      var imgHtml = item.image
        ? '<img src="'+escapeHtml(item.image)+'" alt="'+escapeHtml(item.product_title||'')+'">'
        : '<div class="cd-item-img-fallback" aria-hidden="true">&#127806;</div>';
      var variant = (item.variant_title && item.variant_title!=='Default Title')
        ? '<p class="cd-item-variant">'+escapeHtml(item.variant_title)+'</p>'
        : '';
      var url = item.url || '#';
      li.innerHTML =
        '<a href="'+escapeHtml(url)+'" class="cd-item-img">'+imgHtml+'</a>'+
        '<div class="cd-item-info">'+
          '<a href="'+escapeHtml(url)+'" class="cd-item-title">'+escapeHtml(item.product_title||'')+'</a>'+
          variant+
          '<div class="cd-item-row">'+
            '<div class="cd-qty">'+
              '<button type="button" data-line="'+(idx+1)+'" data-qty="'+(item.quantity-1)+'" aria-label="Decrease">&minus;</button>'+
              '<span>'+item.quantity+'</span>'+
              '<button type="button" data-line="'+(idx+1)+'" data-qty="'+(item.quantity+1)+'" aria-label="Increase">&plus;</button>'+
            '</div>'+
            '<span class="cd-item-price">'+moneyFmt(item.line_price)+'</span>'+
          '</div>'+
          '<button type="button" class="cd-remove" data-line="'+(idx+1)+'">Remove</button>'+
        '</div>';
      list.appendChild(li);
    });

    if(total)total.textContent=moneyFmt(cart.total_price);
  }

  function escapeHtml(s){
    if(s==null)return '';
    return String(s).replace(/[&<>"\']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  /** Parses JSON and pairs it with r.ok so error bodies are never rendered as a cart. */
  function parseJsonWithOk(r){
    return r.json().then(function(body){return {ok:r.ok, body:body};});
  }

  // Delegated click for qty/remove inside the drawer
  document.addEventListener('click', function(e){
    var qtyBtn = e.target.closest('.cd-qty button');
    var rmBtn = e.target.closest('.cd-remove');
    if(!qtyBtn && !rmBtn) return;
    e.preventDefault();
    var btn = qtyBtn || rmBtn;
    var line = parseInt(btn.dataset.line, 10);
    var qty = rmBtn ? 0 : parseInt(btn.dataset.qty||0, 10);
    if(qty < 0) return;
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:line, quantity:qty}),
      credentials:'same-origin'
    })
    .then(parseJsonWithOk)
    .then(function(result){
      if(!result.ok){
        console.error('cart change failed:', result.body);
        return fetchCartAndUpdate();
      }
      var c = result.body;
      renderCartDrawer(c);
      updateHeaderCount(c.item_count);
    })
    .catch(function(err){
      console.error('cart change:', err);
      fetchCartAndUpdate();
    });
  });

  function fetchCartAndUpdate(){
    return fetch('/cart.js', {credentials:'same-origin', cache:'no-store'})
      .then(parseJsonWithOk)
      .then(function(result){
        if(!result.ok){
          console.error('cart fetch failed:', result.body);
          return null;
        }
        var c = result.body;
        renderCartDrawer(c);
        updateHeaderCount(c.item_count);
        return c;
      })
      .catch(function(e){console.error('cart fetch:', e); return null});
  }
  window.fetchCartAndUpdate=fetchCartAndUpdate;

  // ── Init ──
  function init(){
    // Year
    var yr=$('#yr');
    if(yr)yr.textContent=new Date().getFullYear();

    // Mobile overlay closes nav
    var ov=$('#MobileOverlay');
    if(ov)ov.addEventListener('click',closeNav);

    // ESC closes drawers
    document.addEventListener('keydown', function(e){
      if(e.key==='Escape'||e.key==='Esc'){closeNav(); closeCartDrawer();}
    });

    // Sticky header shadow
    var hdr=$('#header');
    if(hdr){
      var onScroll=function(){hdr.classList.toggle('scrolled', window.scrollY>4)};
      window.addEventListener('scroll', onScroll, {passive:true});
      onScroll();
    }

    // Initial cart fetch (silent) - sets cache, updates badge
    fetch('/cart.js', {credentials:'same-origin', cache:'no-store'})
      .then(parseJsonWithOk)
      .then(function(result){
        if(!result.ok)return;
        var c = result.body;
        cartCache = c;
        renderCartDrawer(c);
        updateHeaderCount(c.item_count);
      })
      .catch(function(){});

    // Cart icon -> open drawer immediately, refresh in background
    $$('.cart-btn').forEach(function(btn){
      btn.addEventListener('click', function(e){
        if(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1) return;
        e.preventDefault();
        // Render whatever we have RIGHT NOW
        if(cartCache) renderCartDrawer(cartCache);
        openCartDrawer();
        // Refresh in background - if this fails, drawer stays usable
        fetchCartAndUpdate();
      });
    });

    // AJAX add-to-cart on every form
    $$("form[action='/cart/add'], form[action$='/cart/add']").forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('button[type=submit]');
        var origText = btn ? btn.textContent : '';
        if(btn){btn.disabled=true; btn.textContent='Adding...';}

        var fd = new FormData(form);

        fetch('/cart/add.js', {
          method:'POST',
          body:fd,
          credentials:'same-origin'
        })
        .then(function(r){
          if(!r.ok) throw new Error('Add failed: '+r.status);
          return r.json();
        })
        .then(function(){
          // Open drawer first, fetch cart, then show toast
          openCartDrawer();
          showAddedToast();
          return fetchCartAndUpdate();
        })
        .catch(function(err){
          console.error('add to cart:', err);
          // Don't fall through to native submit - that would reload the page
          // Just re-enable the button so user can try again
        })
        .finally(function(){
          if(btn){btn.disabled=false; btn.textContent=origText;}
        });
      });
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
